// WrappedNavLinks.tsx
import { BaseNavLink } from "Components/Common/Base";
import { withPermission } from "Components/HOCs/withPermission";

export const OverviewNavLink = withPermission(BaseNavLink, {
    module: (props) => props.model,
    skipSubscription: true,
    skipPermission: true,
    action: "overviews",
    featureKey: "overviews",
    tooltipId: "OverviewNavLink-tooltip",
});

export const ActivitiesNavLink = withPermission(BaseNavLink, {
    module: (props) => props.model,
    skipSubscription: true,
    skipPermission: true,
    hideSubscription: true,
    hidePermission: true,
    action: "activities",
    featureKey: "activities",
    tooltipId: "ActivitiesNavLink-tooltip",
});

export const DocumentsNavLink = withPermission(BaseNavLink, {
    module: (props) => props.model,
    skipSubscription: true,
    skipPermission: true,
    hideSubscription: true,
    hidePermission: true,
    action: "documents",
    featureKey: "documents",
    tooltipId: "DocumentsNavLink-tooltip",
});